import {Component, HostBinding, inject, signal} from '@angular/core';
import {connectHits} from 'instantsearch.js/es/connectors';
import {MatButton} from '@angular/material/button';
import {AlgoliaCustomer, CustomerService} from '../../core/services/customer.service';
import {AlgoliaService} from '../../core/services/algolia.service';
import {FlexPosService} from '../../core/services/flex-pos.service';
import parsePhoneNumberFromString from 'libphonenumber-js/min';

@Component({
  selector: 'app-algolia-hits',
  standalone: true,
  imports: [
    MatButton
  ],
  templateUrl: './algolia-hits.component.html',
  styleUrl: './algolia-hits.component.scss'
})
export class AlgoliaHitsComponent {
  private algoliaService = inject(AlgoliaService);
  private customerService = inject(CustomerService);
  private flexPosService = inject(FlexPosService);


  hits = signal<AlgoliaCustomer[]>([]);
  showHits = signal(false);

  @HostBinding('class.hide') get hide() {
    return !this.showHits();
  }

  constructor() {
    this.algoliaService.addWidgets([
      connectHits(({hits, results}) => {
        const hitsData = hits.map((hit: any) => {
          hit._highlightResult['phoneNumber'].value = this.formatPhoneNumber(hit['phoneNumber'].toString(), hit._highlightResult['phoneNumber'].matchedWords);
          return hit
        })

        this.hits.set(hitsData);
        this.showHits.set(results?.query !== '');
      })({}),
    ]);
  }

  formatPhoneNumber(phone: string, match: string[]) {
    let phoneNumber = parsePhoneNumberFromString(phone, 'DK')?.format('NATIONAL', {nationalPrefix: false}) ?? phone;
    match.forEach((m) => {
      // find match in phone number where we ignore spaces and wrap it in a mark tag
      phoneNumber = this.highlightIgnoringSpacesRegex(phoneNumber, m);
    })
    return phoneNumber;
  }

  buildSpaceTolerantRegex(search: string) {
    // Escape special chars if needed, then insert `\s*` between each letter.
    const escaped = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const pattern = escaped.split('').join('\\s*');
    // Entire pattern in capturing group for replace
    return new RegExp('(' + pattern + ')', 'i'); // case-insensitive for example
  }

  highlightIgnoringSpacesRegex(value: string, match: string) {
    const regex = this.buildSpaceTolerantRegex(match);
    // Replace the portion matched (including any intermediate spaces) with <mark>...</mark>
    return value.replace(regex, '<mark>$1</mark>');
  }

  selectFirstCustomer(query = '') {
    const lastResultQuery = this.algoliaService.instantSearchInstance.helper?.lastResults?.query;
    if (query !== lastResultQuery) {
      return;
    }
    if (this.hits().length > 0) {
      this.selectCustomer(this.hits()[0], true);
    }
  }

  selectCustomer(hit: AlgoliaCustomer, addToJournal = false) {
    if (!hit) {
      return;
    }
    this.algoliaService.instantSearchInstance.helper?.setQuery('');
    this.algoliaService.instantSearchInstance.helper?.search();
    this.customerService.selectCustomerByAlgoliaHit(hit);
    if (addToJournal) {
      this.flexPosService.addCustomerToJournal(hit.objectID);
    } else {
      this.flexPosService.clearCustomer();
    }
  }
}
